import { Box, IconButton, Paper, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import { ReferralProgram } from "../types/view.referral";
import ButtonIcon from "../../../components/icons/PenPaperIcon";

interface Props {
  data: ReferralProgram;
}

export default function NotesCard({ data }: Props) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const notes = data.notes ?? [];

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "20px",
        p: 2.5,
        backgroundColor: colors.primary[900],
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography sx={{ fontSize: "1rem", fontWeight: 600 }}>
          Notes
        </Typography>

        <IconButton size="small">
          <ButtonIcon fontSize="small" />
        </IconButton>
      </Box>

      {notes.length === 0 ? (
        <Box
          sx={{
            backgroundColor: "#F5F7FA",
            borderRadius: "14px",
            p: 2,
            color: "#7B8794",
            fontSize: "0.95rem",
          }}
        >
          No notes available at the moment
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {notes.map((note) => (
            <Box
              key={note.id}
              sx={{
                backgroundColor: "#F5F7FA",
                borderRadius: "14px",
                p: 2,
              }}
            >
              <Typography sx={{ color: "#6B7280", mb: 1 }}>
                {note.message}
              </Typography>
              <Typography sx={{ color: "#8A94A6", fontSize: "0.82rem" }}>
                {note.author || "System"} · {note.created_at || "N/A"}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Paper>
  );
}
